import {
    Chart,
    ChartCanvas,
    EdgeIndicator,
    LineSeries,
    withDeviceRatio,
    withSize
} from "@daiver/react-financial-charts";
import { defaultChartCanvasProps, defaultChartEdgeIndicatorProps } from "./liteTradeChartConstants.js";
import { memo } from "react";

function LiteTradeChartTickerLine(props) {
    return <ChartCanvas
        {...defaultChartCanvasProps}
        disableInteraction={true}

        ratio={props.ratio}
        width={props.width}
        data={props.data}
        xScale={props.xScale}
        xAccessor={props.xAccessor}
        xExtents={props.xExtents}
        margin={props.margin}
    >
        <Chart id={1} yExtentsCalculator={props.yExtentsCalculator}>
            {/*<XAxis {...defaultChartXAxisProps}*/}
            {/*       showGridLines={false}*/}
            {/*/>*/}
            {/*<YAxis {...defaultChartYAxisProps}*/}
            {/*       showGridLines={false}*/}
            {/*       tickFormat={d => d.toFixed(props.decimal)}*/}
            {/*/>*/}
            {
                (!props.onlyOneChartLine || props.onlyOneChartLine === 'ask') && <>
                    <LineSeries yAccessor={props.yAccessorAsk}
                                strokeStyle={'#14C679'}
                                strokeWidth={2}/>
                    <EdgeIndicator {...defaultChartEdgeIndicatorProps}
                                   displayFormat={d => d?.toFixed(props.decimal)}
                                   yAccessor={props.yAccessorAsk}
                    />
                </>
            }
            {
                (!props.onlyOneChartLine || props.onlyOneChartLine === 'bid') && <>
                    <LineSeries yAccessor={props.yAccessorBid}
                                strokeStyle={'#FF646C'}
                                strokeWidth={2}/>
                    <EdgeIndicator {...defaultChartEdgeIndicatorProps}
                                   displayFormat={d => d?.toFixed(props.decimal)}
                                   yAccessor={props.yAccessorBid}
                    />
                </>
            }
        </Chart>

    </ChartCanvas>
}

export default withSize({ style: { minHeight: 300 } })((withDeviceRatio()(memo(LiteTradeChartTickerLine))));
